/**
 * Service for mapping extracted data from image to form structure
 */

/**
 * Find college ID by name from controlled vocabulary
 */
const findCollegeId = (collegeName, controlledVocab) => {
  console.log('=== COLLEGE SEARCH DEBUG ===');
  console.log('Searching for:', collegeName);

  if (
    !collegeName ||
    !controlledVocab?.currentTemplate?.templateFields?.instance
  ) {
    return '';
  }

  // Find college field in template
  const collegeField = controlledVocab.currentTemplate.templateFields.instance
    .flatMap((section) => section.sectionFields)
    .find((field) => field.name === 'customFields.Collegename');

  if (!collegeField?.fieldDataOption) {
    return '';
  }

  // Log all available options
  console.log('All college options:');
  collegeField.fieldDataOption.forEach((option, index) => {
    const labels = option.label.map((l) => l.value).join(' | ');
    console.log(`${index + 1}. ${labels} → ${option.value}`);
  });

  // Normalize Arabic text function
  const normalizeArabic = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/إ|أ|آ/g, 'ا') // Normalize alif variations
      .replace(/ة/g, 'ه') // Normalize taa marbouta
      .replace(/ى/g, 'ي') // Normalize alif maqsura
      .replace(/\s+/g, ' ') // Normalize spaces
      .replace(/و\s+/g, 'و'); // Remove space after waw
  };

  const normalizedSearch = normalizeArabic(collegeName);
  console.log('Normalized search:', normalizedSearch);

  // 1. Try exact match first
  let matchingCollege = collegeField.fieldDataOption.find((option) =>
    option.label.some(
      (label) => normalizeArabic(label.value) === normalizedSearch,
    ),
  );

  if (matchingCollege) {
    console.log(
      '✅ EXACT MATCH:',
      matchingCollege.label[0].value,
      '→',
      matchingCollege.value,
    );
    return matchingCollege.value;
  }

  // 2. Try contains match (both directions)
  matchingCollege = collegeField.fieldDataOption.find((option) =>
    option.label.some((label) => {
      const normalizedOption = normalizeArabic(label.value);
      return (
        normalizedOption.includes(normalizedSearch) ||
        normalizedSearch.includes(normalizedOption)
      );
    }),
  );

  if (matchingCollege) {
    console.log(
      '✅ CONTAINS MATCH:',
      matchingCollege.label[0].value,
      '→',
      matchingCollege.value,
    );
    return matchingCollege.value;
  }

  // 3. Try word-by-word match (only significant words)
  const searchWords = normalizedSearch
    .split(' ')
    .filter((word) => word.length > 2);
  matchingCollege = collegeField.fieldDataOption.find((option) =>
    option.label.some((label) => {
      const normalizedOption = normalizeArabic(label.value);
      return searchWords.every((word) => normalizedOption.includes(word));
    }),
  );

  if (matchingCollege) {
    console.log(
      '✅ WORD MATCH:',
      matchingCollege.label[0].value,
      '→',
      matchingCollege.value,
    );
    return matchingCollege.value;
  }

  console.log('❌ NO MATCH FOUND for:', collegeName);
  console.log('=== END COLLEGE DEBUG ===');
  return '';
};

/**
 * Find department ID by name from controlled vocabulary
 */
const findDepartmentId = (departmentName, controlledVocab) => {
  console.log('=== DEPARTMENT SEARCH DEBUG ===');
  console.log('Searching for:', departmentName);

  if (
    !departmentName ||
    !controlledVocab?.currentTemplate?.templateFields?.instance
  ) {
    return '';
  }

  // Find department field in template
  const departmentField =
    controlledVocab.currentTemplate.templateFields.instance
      .flatMap((section) => section.sectionFields)
      .find((field) => field.name === 'customFields.Departmentname');

  if (!departmentField?.fieldDataOption) {
    return '';
  }

  // Log all available options
  console.log('All department options:');
  departmentField.fieldDataOption.forEach((option, index) => {
    const labels = option.label.map((l) => l.value).join(' | ');
    console.log(`${index + 1}. ${labels} → ${option.value}`);
  });

  // Normalize Arabic text function
  const normalizeArabic = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/إ|أ|آ/g, 'ا') // Normalize alif variations
      .replace(/ة/g, 'ه') // Normalize taa marbouta
      .replace(/ى/g, 'ي') // Normalize alif maqsura
      .replace(/\s+/g, ' ') // Normalize spaces
      .replace(/و\s+/g, 'و'); // Remove space after waw
  };

  const normalizedSearch = normalizeArabic(departmentName);
  console.log('Normalized search:', normalizedSearch);

  // 1. Try exact match first
  let matchingDepartment = departmentField.fieldDataOption.find((option) =>
    option.label.some(
      (label) => normalizeArabic(label.value) === normalizedSearch,
    ),
  );

  if (matchingDepartment) {
    console.log(
      '✅ EXACT MATCH:',
      matchingDepartment.label[0].value,
      '→',
      matchingDepartment.value,
    );
    return matchingDepartment.value;
  }

  // 2. Try contains match (both directions)
  matchingDepartment = departmentField.fieldDataOption.find((option) =>
    option.label.some((label) => {
      const normalizedOption = normalizeArabic(label.value);
      return (
        normalizedOption.includes(normalizedSearch) ||
        normalizedSearch.includes(normalizedOption)
      );
    }),
  );

  if (matchingDepartment) {
    console.log(
      '✅ CONTAINS MATCH:',
      matchingDepartment.label[0].value,
      '→',
      matchingDepartment.value,
    );
    return matchingDepartment.value;
  }

  // 3. Try word-by-word match (only significant words)
  const searchWords = normalizedSearch
    .split(' ')
    .filter((word) => word.length > 2);
  matchingDepartment = departmentField.fieldDataOption.find((option) =>
    option.label.some((label) => {
      const normalizedOption = normalizeArabic(label.value);
      return searchWords.every((word) => normalizedOption.includes(word));
    }),
  );

  if (matchingDepartment) {
    console.log(
      '✅ WORD MATCH:',
      matchingDepartment.label[0].value,
      '→',
      matchingDepartment.value,
    );
    return matchingDepartment.value;
  }

  console.log('❌ NO MATCH FOUND for:', departmentName);
  console.log('=== END DEPARTMENT DEBUG ===');
  return '';
};

/**
 * Extract academic degree ID from degree text
 */
const findAcademicDegreeId = (degreeText, controlledVocab) => {
  console.log('=== DEGREE SEARCH DEBUG ===');
  console.log('Searching for degree:', degreeText);
  
  if (!degreeText || !controlledVocab?.currentTemplate?.templateFields?.instance) {
    console.log('No degree text or template');
    return '';
  }

  // Find academic degree field in template
  const degreeField = controlledVocab.currentTemplate.templateFields.instance
    .flatMap((section) => section.sectionFields)
    .find((field) => field.name === 'customFields.AcademicDegree');

  if (!degreeField?.fieldDataOption) {
    console.log('No degree field options');
    return '';
  }

  console.log('Available degree options:');
  degreeField.fieldDataOption.forEach((option, index) => {
    const labels = option.label.map((l) => l.value).join(' | ');
    console.log(`${index + 1}. ${labels} → ${option.value}`);
  });

  const normalizedDegree = degreeText.toLowerCase().trim();
  
  // Search for matching degree
  const matchingDegree = degreeField.fieldDataOption.find((option) =>
    option.label.some((label) => {
      const labelText = label.value.toLowerCase();
      const match = labelText.includes(normalizedDegree) || normalizedDegree.includes(labelText) ||
                   (normalizedDegree.includes('ماجستير') && labelText.includes('ماجستير')) ||
                   (normalizedDegree.includes('master') && labelText.includes('master')) ||
                   (normalizedDegree.includes('دكتوراة') && labelText.includes('دكتوراة')) ||
                   (normalizedDegree.includes('دكتور') && labelText.includes('دكتور')) ||
                   (normalizedDegree.includes('phd') && labelText.includes('phd'));
      
      if (match) {
        console.log('✅ DEGREE MATCH:', label.value, '→', option.value);
      }
      return match;
    }),
  );

  const result = matchingDegree?.value || '';
  console.log('Final degree result:', result || 'NOT FOUND');
  console.log('=== END DEGREE DEBUG ===');
  return result;
};

/**
 * Get contributor type IDs from controlled vocabulary
 */
const getContributorTypeIds = (controlledVocab) => {
  const contributorTypes = controlledVocab?.contributorTypes || [];

  return {
    author:
      contributorTypes.find((type) => type.name === 'Author')?.id ||
      '6e09d47d-95e2-4d8a-831b-f777b8ef6d81',
    advisor:
      contributorTypes.find((type) => type.name === 'Thesis advisor')?.id ||
      'cce475f7-ccfa-4e15-adf8-39f907788515',
    personalName:
      controlledVocab?.contributorNameTypes?.find(
        (type) => type.name === 'Personal name',
      )?.id || '2b94c631-fca9-4892-a730-03ee529ffe2a',
  };
};

/**
 * Map contributors (authors and supervisors)
 */
const mapContributors = (authors, supervisors, contributorTypeIds) => {
  const contributors = [];

  // Add authors
  if (authors?.length > 0) {
    authors.forEach((author) => {
      contributors.push({
        name: author,
        contributorNameTypeId: contributorTypeIds.personalName,
        contributorTypeId: contributorTypeIds.author,
        primary: true,
      });
    });
  }

  // Add supervisors
  if (supervisors?.length > 0) {
    supervisors.forEach((supervisor) => {
      contributors.push({
        name: supervisor,
        contributorNameTypeId: contributorTypeIds.personalName,
        contributorTypeId: contributorTypeIds.advisor,
        primary: false,
      });
    });
  }

  return contributors;
};

/**
 * Map publication data
 */
const mapPublication = (entities) => {
  if (!entities) return [];

  return [
    {
      publisher: entities.university || '',
      dateOfPublication: entities.publication_year || '',
      place: entities.country || '',
    },
  ];
};

/**
 * Map alternative titles
 */
const mapAlternativeTitles = (entities) => {
  console.log('=== ALTERNATIVE TITLES DEBUG ===');
  console.log('entities.subtitle:', entities.subtitle);
  console.log('entities.title:', entities.title);
  
  const alternativeTitles = [];
  
  // Handle subtitle field
  if (entities.subtitle) {
    if (Array.isArray(entities.subtitle) && entities.subtitle.length > 0) {
      // Handle array of subtitles
      entities.subtitle.forEach(subtitle => {
        if (typeof subtitle === 'string' && subtitle.trim()) {
          alternativeTitles.push({
            alternativeTitle: subtitle.trim(),
            alternativeTitleTypeId: '0fe58901-183e-4678-a3aa-0b4751174ba8' // Default subtitle type
          });
          console.log('Added subtitle from array:', subtitle.trim());
        }
      });
    } else if (typeof entities.subtitle === 'string' && entities.subtitle.trim()) {
      // Handle single subtitle string
      alternativeTitles.push({
        alternativeTitle: entities.subtitle.trim(),
        alternativeTitleTypeId: '0fe58901-183e-4678-a3aa-0b4751174ba8' // Default subtitle type
      });
      console.log('Added subtitle from string:', entities.subtitle.trim());
    }
  }
  
  // If no subtitle found but we have a long title, try to extract subtitle from title
  if (alternativeTitles.length === 0 && entities.title) {
    // Look for common subtitle patterns in Arabic titles
    const titleLines = entities.title.split('\n').map(line => line.trim()).filter(line => line);
    if (titleLines.length > 1) {
      // Use second line as subtitle if it exists
      alternativeTitles.push({
        alternativeTitle: titleLines[1],
        alternativeTitleTypeId: '0fe58901-183e-4678-a3aa-0b4751174ba8'
      });
      console.log('Extracted subtitle from title lines:', titleLines[1]);
    }
  }
  
  // Handle any other alternative titles if they exist
  if (entities.alternativeTitles && Array.isArray(entities.alternativeTitles)) {
    entities.alternativeTitles.forEach(altTitle => {
      if (typeof altTitle === 'string' && altTitle.trim()) {
        alternativeTitles.push({
          alternativeTitle: altTitle.trim(),
          alternativeTitleTypeId: '0fe58901-183e-4678-a3aa-0b4751174ba8'
        });
        console.log('Added alternative title:', altTitle.trim());
      }
    });
  }
  
  console.log('Final alternative titles:', alternativeTitles);
  console.log('=== END ALTERNATIVE TITLES DEBUG ===');
  
  return alternativeTitles;
};

/**
 * Map languages
 */
const mapLanguages = (entities) => {
  const languages = [];
  
  // Map common language names to codes
  const languageMap = {
    'العربية': 'ara',
    'arabic': 'ara',
    'الإنجليزية': 'eng',
    'english': 'eng',
    'الفرنسية': 'fre',
    'french': 'fre'
  };
  
  if (entities.language) {
    if (Array.isArray(entities.language)) {
      // Handle array of languages
      entities.language.forEach(lang => {
        if (typeof lang === 'string') {
          const langCode = languageMap[lang.toLowerCase()] || 'ara';
          languages.push(langCode);
        }
      });
    } else if (typeof entities.language === 'string') {
      // Handle single language string
      const langCode = languageMap[entities.language.toLowerCase()] || 'ara';
      languages.push(langCode);
    }
  }
  
  return languages;
};

/**
 * Map custom fields
 */
const mapCustomFields = (entities, controlledVocab) => {
  const customFields = {};

  if (entities.country) {
    customFields.Country = entities.country;
  }

  if (entities.university) {
    customFields.universityName = entities.university;
  }

  if (entities.college) {
    const collegeId = findCollegeId(entities.college, controlledVocab);
    if (collegeId) {
      customFields.Collegename = collegeId;
    }
  }

  if (entities.department) {
    const departmentId = findDepartmentId(entities.department, controlledVocab);
    if (departmentId) {
      customFields.Departmentname = departmentId;
    }
  }

  // Try degree from direct field first, then from additional_info
  if (entities.degree) {
    const degreeId = findAcademicDegreeId(entities.degree, controlledVocab);
    if (degreeId) {
      customFields.AcademicDegree = degreeId;
    }
  } else if (entities.other_entities?.additional_info?.[0]) {
    const degreeId = findAcademicDegreeId(
      entities.other_entities.additional_info[0],
      controlledVocab,
    );
    if (degreeId) {
      customFields.AcademicDegree = degreeId;
    }
  }

  return customFields;
};

/**
 * Main function to map extracted data to form structure
 */
export const mapExtractedDataToForm = (
  extractedData,
  controlledVocab,
  currentTemplate,
) => {
  if (!extractedData?.entities) {
    return {};
  }

  const { entities } = extractedData;
  const contributorTypeIds = getContributorTypeIds(controlledVocab);

  const result = {
    title: entities.title || '',
    contributors: mapContributors(
      entities.authors,
      entities.supervisors,
      contributorTypeIds,
    ),
    publication: mapPublication(entities),
    customFields: mapCustomFields(entities, {
      ...controlledVocab,
      currentTemplate,
    }),
    alternativeTitles: mapAlternativeTitles(entities),
    languages: mapLanguages(entities)
  };
  
  console.log('=== FINAL MAPPING RESULT ===');
  console.log('Alternative titles:', result.alternativeTitles);
  console.log('Languages:', result.languages);
  console.log('Custom fields:', result.customFields);
  console.log('=============================');
  
  return result;
};

export default {
  mapExtractedDataToForm,
  findCollegeId,
  findDepartmentId,
  findAcademicDegreeId,
  getContributorTypeIds,
};
